import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'
import _ from 'lodash'

const service = new ApolloClientService()

export default class Company {
  getCompanies = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCompanies(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addEditCompany = (params) => {
    return new Promise((resolve, reject) => {
      service
        .addEditCompany(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  getCompany = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCompany(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  addEditSupportProfile = (params) => {
    return new Promise((resolve, reject) => {
      service
        .addEditSupportProfile(params)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }

  deleteSupportProfile = (companyid, id) => {
    return new Promise((resolve, reject) => {
      service
        .deleteSupportProfile(companyid, id)
        .then((data) => {
          if (data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            data.error = true
            reject(data)
          }
        })
        .catch((err) => console.log(err))
    })
  }
}
